<template>
    <div>
        <div class="modal-overlay active" @click="closeDialog"></div>
        <div class="modal">
            <div class="modal__header">
                <h2 class="headline-s">Revoke token</h2>
                <CloseIcon class="modal__header--close" alt="Close modal" aria-label="Close modal" @click="closeDialog" />
            </div>
            <div class="modal__body flex-column">
                <p class="paragraph-details">
                    Are you sure you want to revoke <span class="strong">{{ tokenName }}</span>? This action removes access immediately and cannot be undone.
                </p>
                <div class="token-form__actions">
                    <RothcoCta type="button" class="secondary" :button_icon="null" aria-label="Cancel revoke" @click.prevent="closeDialog">
                        Cancel
                    </RothcoCta>
                    <RothcoCta
                        type="button"
                        class="primary"
                        button_icon="carret"
                        :disabled="submitting"
                        aria-label="Confirm revoke token"
                        @click.prevent="confirm"
                    >
                        Revoke token
                    </RothcoCta>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed, inject, ref } from 'vue';
import RothcoCta from '@/components/RothcoCta.vue';
import CloseIcon from '@icons/closeIcon.svg';

type ModalData = {
    tokenName?: string;
    onConfirm?: () => Promise<void> | void;
};

const dialogRef = inject<any>('dialogRef');
const submitting = ref(false);

const tokenName = computed(() => (dialogRef?.value?.data as ModalData | undefined)?.tokenName ?? 'this token');
const onConfirm = (dialogRef?.value?.data as ModalData | undefined)?.onConfirm;

function closeDialog() {
    dialogRef?.value?.close();
}

async function confirm() {
    if (submitting.value) return;
    submitting.value = true;
    try {
        await onConfirm?.();
        closeDialog();
    } finally {
        submitting.value = false;
    }
}
</script>

<style scoped lang="scss">
@import "../assets/styles/variables.scss";

.token-form__actions {
    display: flex;
    justify-content: flex-end;
    gap: 0.75rem;
    margin-top: 1rem;
}

.strong {
    font-weight: 600;
}
</style>
